import React from "react";

// styles
import * as Styled from './styles';

function LogosContainer({ logos, vSize }) {
    return (
       <Styled.Container>
           {
               logos.map((logo, index) => {
                   return <Styled.Logo key={index} vSize={vSize}>
                        { logo.link ? 
                            <a href={logo.link} >
                                <img src={"imgs/"+logo.src} alt={logo.alt} />
                            </a>
                        : 
                            <img src={"imgs/"+logo.src} alt={logo.alt} />
                        }
                   </Styled.Logo>
               })
           }
       </Styled.Container>
    );
}

export default LogosContainer;
